import { AnyAction } from 'redux';
import { PaginatedResponse } from '@synergy/api';
import { defaultPageSize } from '@synergy/config';

import {
    CLEAR_INQUIRY_DATA,
    DECLINE_INQUIRY,
    RECEIVE_INQUIRY_DATA,
    REQUEST_INQUIRY_DATA,
    RESET_INQUIRIES,
} from '../actions/inquiry-actions';
import { Inquiry } from '../../../common/models/inquiry';
import { Offer } from '../../../common/models/offer';
import { OfferStatus } from '../../../common/models/enums/offer-status';

export interface InquiryDataReducerState {
    data: PaginatedResponse<Inquiry>;
    requesting: boolean;
}

const initialListDataReducerState: InquiryDataReducerState = {
    data: { items: [], page: 0, limit: defaultPageSize, total: 0 },
    requesting: false,
};

export const inquiriesReducer = (
    state: InquiryDataReducerState = initialListDataReducerState,
    action: AnyAction
): InquiryDataReducerState => {
    const { type, ...rest } = action;
    switch (type) {
        case DECLINE_INQUIRY: {
            let inquiries = state.data.items;
            inquiries = updateOffers(inquiries, rest['inquiryId'], offer => (offer.status = OfferStatus.Declined));
            return {
                ...state,
                data: { ...state.data, items: inquiries },
            };
        }

        case REQUEST_INQUIRY_DATA: {
            return {
                ...state,
                requesting: true,
            };
        }

        case RECEIVE_INQUIRY_DATA: {
            return {
                ...state,
                data: rest['data'],
                requesting: false,
            };
        }

        case CLEAR_INQUIRY_DATA: {
            return {
                ...initialListDataReducerState,
            };
        }

        case RESET_INQUIRIES: {
            return {
                ...state,
                data: initialListDataReducerState.data,
            };
        }

        default: {
            return state;
        }
    }
};

const updateOffers = (inquiries: Inquiry[], inquiryId: number, update: (offer: Offer) => void): Inquiry[] => {
    const inquiry = inquiries.find(i => i.id === inquiryId);
    if (!inquiry) {
        return inquiries;
    }
    const result = [...inquiries];
    const index = result.findIndex(i => i.id === inquiryId);
    const inquiryClone = Inquiry.fromPlainObject(inquiry);
    inquiryClone.accountPurchases.forEach(accountPurchase => {
        accountPurchase.offers.forEach(offer => {
            update(offer);
        });
    });
    result[index] = inquiryClone;
    return result;
};
